import { DataTable } from "@rumble-it/common-components/components";
import { getUserPermissionsForTable } from "@/pages/admin/users/permissions/lib/queries";
import { useEffect, useState } from "react";

export const UserPermissionsTable = () => {
  const [userPermissions, setUserPermissions] = useState([]);

  const getUserPermissions = async () => {
    setUserPermissions(await getUserPermissionsForTable());
  };

  useEffect(() => {
    getUserPermissions();
  }, []);

  return (
    <DataTable
      tableData={{
        columns: [
          { key: "name", label: "Naam" },
          {
            key: "show",
            label: "Acties",
            className: "text-right",
          },
        ],
        data: userPermissions,
      }}
    />
  );
};
